import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { BookingPeriod } from '../types/types';

interface UseBookingPeriodReturn {
  bookingPeriods: BookingPeriod[];
  selectedBookingPeriod: BookingPeriod | null;
  setSelectedBookingPeriod: (period: BookingPeriod | null) => void;
  loading: boolean;
  error: string;
}

export const useBookingPeriod = (): UseBookingPeriodReturn => {
  const [bookingPeriods, setBookingPeriods] = useState<BookingPeriod[]>([]);
  const [selectedBookingPeriod, setSelectedBookingPeriod] = useState<BookingPeriod | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchBookingPeriods = async () => {
      try {
        setLoading(true);
        const q = query(
          collection(db, 'booking_periods'),
          orderBy('booking_open_at', 'desc')
        );
        const querySnapshot = await getDocs(q);
        const bp: BookingPeriod[] = [];
        querySnapshot.forEach((doc) => {
          bp.push({ id: doc.id, ...(doc.data() as Omit<BookingPeriod, 'id'>) });
        });
        setBookingPeriods(bp);
        if (bp.length > 0) {
          setSelectedBookingPeriod(bp[0]);
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBookingPeriods();
  }, []);

  return {
    bookingPeriods,
    selectedBookingPeriod,
    setSelectedBookingPeriod,
    loading,
    error,
  };
};
